/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateShopInsideRadiusCorner } from "api/actions/price_list";
/// TYPES ///
import { IInsideRadiusCorner } from "api/types/price_list/corner/inside_radius";
/// COMPONENTS ///
import PriceRow from "../../row";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  last: boolean,
  inside_radius_corner: IInsideRadiusCorner
}

export default function InsideRadiusCorner({ index, last, inside_radius_corner }: Props) {
  const dispatch = useAppDispatch();

  return (
    <PriceRow
      index={index}
      last={last}
      original_price={inside_radius_corner?.price ?? 0}
      title={getMaterialHeightDisplay(inside_radius_corner?.material_thickness ?? "")}
      end_text="$"
      end_padding="45px"
      update={price => dispatch(updateShopInsideRadiusCorner({ price: price }, inside_radius_corner.id))} />
  )
}
